import { useState, useEffect } from "react";
import BookSection from "./BookSection";
import { InfinitySpin } from 'react-loader-spinner'

async function loadAdventure(id) {
    try {
        const adventure = await import(`../../../jsons/adventures/adventureData/adventure-${id.toLowerCase()}.json`);
        return adventure.data;
    } catch(error) {
        console.error(`Failed to load adventure ${id}:`, error);
    }
}

const Book = ({ bookinfo, handleSelectCreature }) => {
    
    const [isOpen, setIsOpen] = useState(false);
    const [bookData, setBookData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        // If book is opened save it
        if (isOpen) {
            localStorage.setItem(`book-${bookinfo.id}`, JSON.stringify(isOpen));
        } else {
            // if closed but previously opened, remove it from storage
            if(bookData) {
                localStorage.removeItem(`book-${bookinfo.id}`);
            } else { // if book has never been opened check if it should be opened (first load)
                const isSaved = localStorage.getItem(`book-${bookinfo.id}`);
                if(isSaved)
                    toggleOpen()
            }
        }
    }, [isOpen, bookinfo.id]);

    const toggleOpen = async () => {
        if(!bookData && !loading) {
            setLoading(true);
            try {
                const data = await loadAdventure(bookinfo.id);
                setBookData(data);
                
            } catch(err) {
                setError(err.message);
            } finally {

                setTimeout(() => {
                    setLoading(false);
                }, 1000); // Force re-render

            }
        }
        setIsOpen(open => !open);
    } 

    return (
        <div style={{border: isOpen ? "4px solid #822000" : "none"}} key={bookinfo.id + "inner"}>
            <div className='bookListContainer' style={{outline: isOpen ? "2px solid #000000ff" : "none"}} onClick={toggleOpen}>
                <div className='topSpellInfo shadowBox'>
                    <span className=''><b>{bookinfo.name}</b> - {bookinfo.id} - {bookinfo.published.split("-")[0]}</span>
                </div>
                <div style={{cursor: 'pointer'}}>
                    <svg width="16" height="16" viewBox="0 0 16 16" style={{
                        verticalAlign: "middle",
                        transition: "transform 0.2s",
                        transform: isOpen ? "rotate(0deg)" : "rotate(90deg)"
                    }}>
                        <polyline points="4,6 8,10 12,6" fill="none" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
            </div>


            {error && <div className='error'>Error loading adventure: {error}</div>}

            {(isOpen && loading) && 
                <InfinitySpin visible={true} width="200" color="#822000" ariaLabel="infinity-spin-loading" />     
            }

            {(isOpen && !loading) && 
                <>
                    <ul className='bookListUL' style={{paddingBottom: "10px"}}>
                        {bookData?.map((section, idx) => {
                            return (
                                <BookSection key={bookinfo.id + " " + idx} content={section.entries} label={section.name} page={section.page} cKey={bookinfo.id} handleSelectCreature={handleSelectCreature}/>
                            )
                        })}
                    </ul>
                    <hr className="lineSeperator" />
                </>
            }

            
            <hr className="lineSeperator" />
        </div>
    );
};

export default Book;